import { Row } from "react-bootstrap"

import * as S from "./styled"

import Cart from "../../Cart"

export default function Main({ isMobile }) {
  return (
    <S.Wrapper>
      <Row noGutters>
        <S.MainWindow isMobile={isMobile}>
          <Cart />
        </S.MainWindow>
      </Row>
    </S.Wrapper>
  )
}
